import Component from 'component';

class CookieUseDisclaimer extends Component{
  constructor(el, config){
    super(el, config);
  }

  setupDefaults(){
    this.dom = {
      $closeBtn: this.$el.find('.wh-cookie-use-disclaimer__btn-close')
    };

    this.cssClasses = {
      close: 'close'
    }
  }

  addListeners(){
    this.dom.$closeBtn.on('click touch', ::this.onClose);
  }

  onClose(e) {
    e.preventDefault();

    this.$el.addClass(this.cssClasses.close);

    $.post(this.config.endpoint, {
      Guid: this.$el.data('guid')
    });
  }
}

export default CookieUseDisclaimer;



// WEBPACK FOOTER //
// ./src/js/components/global/CookieUseDisclaimer.js